const messages = {
  title: "Bericht erstellen",
  personal_data: {
    title: "Persönliche Daten",
    email: "E-Mail",
    salutation: "Anrede",
    first_name: "Vorname",
    last_name: "Nachname",
    job_position: "Position im Unternehmen",
  },
  shipping_address: {
    title: "Lieferadresse",
    company: "Firmenname",
    street: "Strasse & Hausnummer",
    postal_code: "Postleitzahl",
    mobile_phone: "Mobiltelefon",
    iban_number: "IBAN",
    vat: "USt-Nummer",
    additional_address: "Zusatzadresse",
    city: "Stadt",
  },
  operating_data: {
    title: "Betriebsdaten",
    customer_number: "Kundennummer",
    group: "Gruppe",
    customer_group: "Gruppe",
    first_registration: "Erstregistrierung",
    last_login: "Letzte Anmeldung",
    tires_per_year: "Reifen pro Jahr",
    over_18_inch: "Über 18 Zoll",
    premium: "Premium",
    middle: "Mittel",
    summer: "Sommer",
    winter: "Winter",
    all_season: "Ganzjahresreifen",
  },
  calculated_data: {
    title: "Berechnete Daten",
    tireAmount: "Reifenanzahl",
    points: "Punkte",
    bonus: "Bonus",
  },
  sales_structure: {
    title: "Vertriebsstruktur",
    sales_representative: {
      title: "Vertriebsmitarbeiter",
    },
    distributor: {
      title: "Distributor",
    },
  },
  meta: {
    title: "Metadaten",
    brand: {
      title: "Marke",
      none: "",
    },
    tireType: {
      title: "Reifentyp",
      none: "",
    },
    year: {
      2020: "2020",
      2021: "2021",
      2022: "2022",
      2023: "2023",
      2024: "2024",
      2025: "2025",
      title: "Jahr",
    },
    calendarMonth: {
      title: "Kalendermonat",
      january: "Jänner",
      february: "Februar",
      march: "März",
      april: "April",
      may: "Mai",
      june: "Juni",
      july: "Juli",
      august: "August",
      september: "September",
      october: "Oktober",
      november: "November",
      december: "Dezember",
    },
  },
  selectAll: "Alle auswählen",
  reset: "Filter zurücksetzen",
  generate: "Bericht erstellen",
  loadingInfo: "Bericht wird erstellt, bitte warten...",
};

export default {
  messages,
};
